export const sliderItems = [
  {
    id: 1,
    img: "https://www.concentrix.com/wp-content/uploads/2022/09/retail-ecommerce-circ-banner.png",
    title: "Festival Sale",
    desc: "Don't compromise on style! Get flat 30% off for new arrivals.",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: "https://www.concentrix.com/wp-content/uploads/2022/09/retail-ecommerce-circ-banner.png",
    title: "Winter Sale",
    desc: "Don't compromise on style! Get flat 30% off for new arrivals.",
    bg: "fcf1ed",
  },
  {
    id: 1,
    img: "https://www.concentrix.com/wp-content/uploads/2022/09/retail-ecommerce-circ-banner.png",
    title: "Popular Sale",
    desc: "Don't compromise on style! Get flat 30% off for new arrivals.",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    title: "Shirt Style!",
    cat: "man",
  },
  {
    id: 2,
    img: "https://cdn.zivame.com/ik-seo/media/zcmsimages/configimages/ZI61KO-Medieval%20Blue/1_medium/zivame-viscose-blend-waffle-lounge-set-medieval-blue.JPG?t=1641814803",
    title: "Loungewear Love",
    cat: "women",
  },
  {
    id: 3,
    img: "https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/14646066/2021/12/21/2d26ca3f-000f-4a8d-8b82-0dc496feb6e41640068266663-HRX-by-Hrithik-Roshan-Men-Jackets-4791640068265267-3.jpg",
    title: "Light Jackets",
    cat: "jackets",
  },
];

export const popularProducts = [
  {
    id: 1,
    img: "https://thumbs.dreamstime.com/b/blue-shoes-29507491.jpg",
  },
  {
    id: 2,
    img: "https://assets.myntassets.com/dpr_1.5,q_60,w_400,c_limit,fl_progressive/assets/images/10341699/2022/8/25/c23fd879-a9b3-4515-a181-558523a71b9b1661423122029-LOCOMOTIVE-Men-Black--Grey-Slim-Fit-Checked-Casual-Shirt-342-1.jpg",
  },
  {
    id: 3,
    img: "https://media.istockphoto.com/photos/color-women-bag-display-on-white-background-picture-id1159213603?k=20&m=1159213603&s=612x612&w=0&h=T8LsiuyBRkNfIuiwx2MCG1VRXKrkbgshTv2IX_310K8=",
  },
  {
    id: 4,
    img: "https://media.istockphoto.com/photos/luxury-watches-picture-id628540774?k=20&m=628540774&s=612x612&w=0&h=sNXnUlyLZf9NOSCpSIwN82Js9B2RsI_ckHDgx547p-c=",
  },
  {
    id: 5,
    img: "https://images.cbazaar.com/images/custom-made-magenta-foil-print-princess-cut-kurti-KRBS01908553-pl.jpg",
  },
  {
    id: 6,
    img: "https://cdn.thewirecutter.com/wp-content/media/2022/08/water-bottle-2048px-mira.jpg",
  },
  {
    id: 7,
    img: "https://images.unsplash.com/photo-1578932750294-f5075e85f44a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Y2xvdGhlcyUyMHNob3B8ZW58MHx8MHx8&w=1000&q=80",
  },
  {
    id: 8,
    img: "https://hips.hearstapps.com/hmg-prod.s3.amazonaws.com/images/womens-loungewear-2021-1611329248.png?crop=0.5xw:1xh;center,top&resize=640:*",
  },
];
